import React from 'react';

const AppLayoutWrapper = ({ children }) => {
  return (
    <section className="p-faq">
      <section className="l-page">
        {children}
      </section>
    </section>
    
  );
};

export default AppLayoutWrapper;